import NavBar from "./Navbar";
import { Outlet } from "react-router-dom";
import ChatbotWidget from './ChatbotWidget';

function App() {

  return (
    <div>
      {/* Nav and Page Content */}
      <NavBar />
      <Outlet />
      <ChatbotWidget />

      <footer className="bg-navy text-white p-6">
      {/* Top Row: Contact & Address */}
      <div className="flex flex-col md:flex-row md:justify-between md:items-start mb-6 text-sm text-center md:text-left">
        {/* Left: Phone & Email */}
        <div className="mb-2 md:mb-0">
          <a href="tel:7702297242" className="underline block">(770) 229-7242</a>
          <a href="mailto:office@wonderkidsacademy.org" className="underline block">office@wonderkidsacademy.org</a>
        </div>

        {/* Right: Address */}
        <div>
          <p className="footer-add">
            <a
              href="https://www.google.com/maps/search/?api=1&query=4665+Macland+Rd,+Powder+Springs,+GA+30127"
              target="_blank"
              rel="noopener noreferrer"
              className="underline"
            >
              4665 Macland Rd,<br />
              Powder Springs, GA 30127
            </a>
          </p>
        </div>
      </div>

  {/* Centered CAPS Section */}
  <div className="text-center max-w-3xl mx-auto">
    <h1 className="text-base font-medium mb-3">We are a CAPS-Certified Provider</h1>
    <h3 className="text-sm font-medium leading-snug mb-2">
      Our daycare is proud to be CAPS Certified through Georgia’s Childcare and Parent Services (CAPS) program. This means we meet the state's standards for providing quality care and accept CAPS subsidies to help eligible families cover the cost of childcare.
    </h3>
    <h3 className="text-sm font-medium leading-snug mt-2">
      To learn more about the CAPS program or to check your eligibility, visit: 
      <a href="https://caps.decal.ga.gov" target="_blank" rel="noreferrer" className="underline text-blue-300 ml-1">caps.decal.ga.gov</a>
    </h3>
  </div>
</footer>

    </div>
  );
}

export default App;
